/* global SideDrawer */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');
      this.expanded = [];
      this.filterChangeTimeout = null;

      this.handleBreakpointChange();
      this.addElements();
      this.addListeners();

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    addElements() {
      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footerWrapper = this.querySelector('.drawer__footer');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll('.js-drawer-sort-by');
        this.desktopSortBy = document.querySelector('.products-toolbar__sort');
      }
    }

    addListeners() {
      if (this.filteringEnabled) {
        this.breakpointChangeHandler = this.breakpointChangeHandler
          || this.handleBreakpointChange.bind(this);
        this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        this.filters.addEventListener('input', this.handleFilterChange.bind(this));
        this.filters.addEventListener('change', this.handleFilterChange.bind(this));
        this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));
        if (this.footer) {
          this.footer.addEventListener('click', this.handleFooterClick.bind(this));
        }
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }

      if (this.sortingEnabled) {
        this.desktopSortBy.addEventListener('change', this.handleFilterChange.bind(this));
      }
    }

    /**
     * Handles viewport breakpoint changes.
     */
    handleBreakpointChange() {
      const isLargeScreen = theme.mediaMatches.lg;
    
      if (isLargeScreen) {
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
        this.hidden = false;
      } else {
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
        this.hidden = false; 
      }
    }
    
    
    
    
    

    /**
     * Handles 'input' events on the filters and 'change' events on the sort by dropdown.
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      // Only allow price 'change' events
      if (
        evt.type === 'change'
        && !(evt.target.id?.includes('price-range')
          || evt.target.id?.includes('sort-by')
          || evt.target.matches('[data-role="lagerstatus-toggle"]'))
      ) return;

      // Dont reload when typing a price
      if (evt.target.id?.includes('price-range') && evt.constructor.name === 'InputEvent') return;

      this.setFilteringState(evt);

      const timeoutDelay = evt.target.id?.includes('price-range') ? 500 : 150;

      clearTimeout(this.filterChangeTimeout);

      this.filterChangeTimeout = setTimeout(() => {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const emptyParams = [];

        if (this.sortingEnabled) {
          let currentSortBy = searchParams.get('sort_by');

          // Keep the mobile facets form sync'd with the desktop sort by dropdown
          if (evt.target.tagName === 'CUSTOM-SELECT') {
            this.mobileSortByOptions.forEach((option) => {
              option.checked = option.value === evt.detail.selectedValue;
              currentSortBy = evt.detail.selectedValue;
            });
          }

          // Set the 'sort_by' parameter.
          searchParams.set('sort_by', currentSortBy);
        }

        // Get empty parameters.
        searchParams.forEach((value, key) => {
          if (!value) emptyParams.push(key);
        });

        // Remove empty parameters.
        emptyParams.forEach((key) => {
          searchParams.delete(key);
        });

        this.applyFilters(searchParams.toString(), evt);
      }, timeoutDelay);
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;
      const priceClearButton = target.closest('.js-clear-price-filter');

      if (priceClearButton) {
        evt.preventDefault();
        const removeUrl = priceClearButton.dataset.urlToRemove;
        this.setFilteringState(evt);
        if (removeUrl) {
          this.applyFilters(new URL(removeUrl, window.location.origin).searchParams.toString(), evt);
        }
        return;
      }

      if (target.closest('.filter__label, .toggle-label')) {
        this.setFilteringState(evt);
      }

      const activePriceInput = target.matches('input[type="radio"][data-url-to-remove]')
        ? target
        : null;
      const activePriceLabel = target.closest('.price-filter-label[data-url-to-remove]');
      const activePriceLabelInput = activePriceLabel
        ? document.getElementById(activePriceLabel.getAttribute('for'))
        : null;

      if (activePriceInput || activePriceLabelInput?.checked) {
        const removeUrl = activePriceInput?.dataset.urlToRemove || activePriceLabel?.dataset.urlToRemove;
        if (removeUrl) {
          evt.preventDefault();
          this.setFilteringState(evt);
          this.applyFilters(new URL(removeUrl, window.location.origin).searchParams.toString(), evt);
          return;
        }
      }

      // Filter 'clear' button clicked.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.setFilteringState(evt);
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });

        if (!this.expanded.includes(filter.id)) {
          this.expanded.push(filter.id);
        }
      }
    }

    /**
     * Handles 'click' events on the active filters.
     * @param {object} evt - Event object.
     */
    handleActiveFiltersClick(evt) {
      const activeFilterLink = evt.target.closest('a');
      if (!activeFilterLink) return;
      evt.preventDefault();
      if (activeFilterLink.classList.contains('js-clear-all')) {
        this.setClearAllLoading(activeFilterLink);
      } else {
        activeFilterLink.classList.add('is-loading');
        activeFilterLink.setAttribute('aria-busy', 'true');
      }
      this.applyFilters(new URL(activeFilterLink.href).searchParams.toString(), evt);
    }

    handleFooterClick(evt) {
      const clearAllLink = evt.target.closest('.js-clear-all');
      if (!clearAllLink) return;

      evt.preventDefault();
      this.setClearAllLoading(clearAllLink);
      this.setFilteringState(evt);
      this.applyFilters(new URL(clearAllLink.href).searchParams.toString(), evt);
    }

    setClearAllLoading(activeLink) {
      const links = document.querySelectorAll('.js-clear-all');

      links.forEach((link) => {
        const sameDestination = activeLink && link.href === activeLink.href;
        if (link === activeLink || sameDestination) {
          link.classList.add('is-loading');
          link.setAttribute('aria-busy', 'true');
          link.setAttribute('aria-disabled', 'true');
        }
      });
    }

    setFilteringState(evt) {
      const target = evt?.target;
      const nestedPanel = target?.closest?.('.filter__drawer-panel')
        || this.querySelector('.filter__drawer-panel.open');
      const loadingTarget = nestedPanel || this;

      this.querySelectorAll('.filter__drawer-panel.is-filtering').forEach((panel) => {
        if (panel !== loadingTarget) {
          panel.classList.remove('is-filtering');
          panel.removeAttribute('aria-busy');
        }
      });

      if (loadingTarget) {
        loadingTarget.classList.add('is-filtering');
        loadingTarget.setAttribute('aria-busy', 'true');
      }
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';

        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }

        this.applyFilters(searchParams, null, false);
      }
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(searchParams, evt, updateUrl = true) {
      try {
        // Preserve the current element focus
        const activeElementId = document.activeElement.id;
        const activeDrawer = evt?.target?.closest('.filter__drawer-panel')
          || this.querySelector('.filter__drawer-panel.open');
        const activeDrawerId = activeDrawer?.id;
        const activeControl = evt?.target?.matches('input, select, custom-select') ? evt.target : null;
        const activeControlId = activeControl?.id;
        const escapedActiveControlId = activeControlId && window.CSS?.escape
          ? CSS.escape(activeControlId)
          : activeControlId?.replace(/"/g, '\\"');
        const activeControlLabel = activeControl?.id
          ? this.form.querySelector(`label[for="${escapedActiveControlId}"]`)
          : null;

        // Disable infinite scrolling.
        const customPagination = document.querySelector('custom-pagination');
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

        // Set loading state.
        this.classList.add('facets--loading');
        this.setFilteringState(evt);
        const filterDrawerOpen = document.getElementById('FilterDrawer')?.classList.contains('open');
        if (!activeDrawer && !filterDrawerOpen) {
          this.results.classList.add('is-loading');
        }
        // Disable "Show X results" button until submission is complete.
        const closeBtn = this.querySelector('.js-close-drawer-mob');
        if (closeBtn) {
          closeBtn.ariaDisabled = 'true';
        }

        // Use Section Rendering API for the request, if possible.
        let fetchUrl = `${window.location.pathname}?${searchParams}`;
        if (this.form.dataset.filterSectionId) {
          fetchUrl += `&section_id=${this.form.dataset.filterSectionId}`;
        }

        // Cancel current fetch request. (Raises an exception)
        if (this.applyFiltersFetchAbortController) {
          this.applyFiltersFetchAbortController.abort('Request changed');
        }
        this.applyFiltersFetchAbortController = new AbortController();

        // Fetch filtered products markup.
        const response = await fetch(fetchUrl, {
          method: 'GET',
          signal: this.applyFiltersFetchAbortController.signal
        });

        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          // Restore UI state.
          this.form.querySelectorAll('details-disclosure > details').forEach((existingFilter) => {
            const target = tmpl.content.getElementById(existingFilter.id);
            if (target) {
              target.open = existingFilter.open;
            }
          });
          tmpl.content.querySelectorAll('#facets details-disclosure > details').forEach((newFilter) => {
            if (this.expanded.includes(newFilter.id)) {
              const hiddenElements = newFilter.querySelectorAll('.js-hidden');
              hiddenElements.forEach((listItem) => {
                listItem.classList.remove('js-hidden');
              });
              newFilter.querySelector('.filter__more')?.remove();
            }
          });

          // Update the filters.
          this.form.innerHTML = tmpl.content.getElementById('facets').innerHTML;

          if (activeDrawerId) {
            const nextActiveDrawer = Array.from(this.querySelectorAll('.filter__drawer-panel'))
              .find((panel) => panel.id === activeDrawerId);

            if (nextActiveDrawer) {
              nextActiveDrawer.classList.add('open');
              nextActiveDrawer.closest('details')?.setAttribute('open', '');
              requestAnimationFrame(() => {
                const nextDrawerContent = nextActiveDrawer.querySelector('.filter__drawer-content');
                nextActiveDrawer.scrollTop = 0;
                if (nextDrawerContent) nextDrawerContent.scrollTop = 0;
              });
            }
          }

          // Replace hidden active filters section.
          const newHiddenFilters = tmpl.content.querySelector('#active-filters-hidden');
          const currentHiddenFilters = document.querySelector('#active-filters-hidden');

          if (newHiddenFilters && currentHiddenFilters) {
            currentHiddenFilters.innerHTML = newHiddenFilters.innerHTML;
          }

          // Update the mobile footer actions.
          const newFacets = tmpl.content.querySelector('facet-filters');
          const newFooterWrapper = newFacets?.querySelector('.drawer__footer');
          const newFooter = newFacets?.querySelector('.facets__footer');
          const currentFooterWrapper = this.querySelector('.drawer__footer');

          if (newFooterWrapper && currentFooterWrapper) {
            currentFooterWrapper.className = newFooterWrapper.className;
            currentFooterWrapper.innerHTML = newFooterWrapper.innerHTML;
          } else if (newFooter && this.footer) {
            this.footer.className = newFooter.className;
            this.footer.innerHTML = newFooter.innerHTML;
          } else if (closeBtn) {
            closeBtn.innerText = tmpl.content.querySelector('.js-close-drawer-mob')?.innerText || closeBtn.innerText;
          }

          // Preserve the CSS class of the results
          const currentResultsUl = this.results.querySelector('ul');
          this.currentResultsClass = currentResultsUl ? this.results.querySelector('ul').getAttribute('class') : this.currentResultsClass;

          // Update the results.
          this.results.innerHTML = tmpl.content.getElementById('filter-results').innerHTML;

          // Set the CSS class of the results to what it was
          const newResultsUl = this.results.querySelector('ul');
          if (newResultsUl && this.currentResultsClass) newResultsUl.setAttribute('class', this.currentResultsClass);

          // Reinitialize re-rendered components.
          this.addElements();
          this.addListeners();

          // Reinitialize any custom pagination
          if (customPagination && customPagination.reload) customPagination.reload();

          // Update the URL.
          if (updateUrl) FacetFilters.updateURL(searchParams);

          // Scroll to the top of the results if needed
          const filterDrawerOpen = document.getElementById('FilterDrawer')?.classList.contains('open');
          if (!filterDrawerOpen && this.results.getBoundingClientRect().top < 0) {
            // If the header is sticky, compensate for it when scrolling to elements
            let headerHeight = 0;
            if (document.querySelector('store-header[data-is-sticky="true"]')) {
              headerHeight = Number.parseInt(
                getComputedStyle(this.parentElement)
                  .getPropertyValue('--header-height')
                  .replace('px', ''),
                10
              ) || 0;
            }
            window.scrollTo({
              top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
              behavior: 'smooth'
            });
          }

          // Enable the "Show X results" button
          if (closeBtn) {
            closeBtn.removeAttribute('aria-disabled');
          }

          // Renable infinite scroll
          if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'false';

          // Focus on the element with the same ID in the new HTML without moving the nested drawer scroll.
          if (activeElementId) {
            const activeElement = document.getElementById(activeElementId);
            if (activeElement) {
              try {
                activeElement.focus({ preventScroll: true });
              } catch (error) {
                activeElement.focus();
              }
            }
          }

          if (activeDrawerId) {
            requestAnimationFrame(() => {
              const activeDrawer = Array.from(this.querySelectorAll('.filter__drawer-panel'))
                .find((panel) => panel.id === activeDrawerId);
              const activeDrawerContent = activeDrawer?.querySelector('.filter__drawer-content');
              if (activeDrawer) activeDrawer.scrollTop = 0;
              if (activeDrawerContent) activeDrawerContent.scrollTop = 0;
            });
          }

          // Broadcast the update for anything else to hook into
          document.dispatchEvent(new CustomEvent('on:facet-filters:updated'), { bubbles: true });
        }
      } catch (error) {
        console.warn(error); // eslint-disable-line
      } finally {
        this.classList.remove('facets--loading');
        this.classList.remove('is-filtering');
        this.removeAttribute('aria-busy');
        this.querySelectorAll('.filter__drawer-panel.is-filtering').forEach((panel) => {
          panel.classList.remove('is-filtering');
          panel.removeAttribute('aria-busy');
        });
        this.querySelectorAll('.filter__label.is-loading, .toggle-label.is-loading').forEach((label) => {
          label.classList.remove('is-loading');
          label.removeAttribute('aria-busy');
        });
        document.querySelectorAll('.active-filter.is-loading, .js-clear-all.is-loading').forEach((link) => {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
        });
        this.results.classList.remove('is-loading');
      }
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof syncFiltersOnPageLoad === 'function') syncFiltersOnPageLoad();
    if (typeof initPriceFilterScript === 'function') initPriceFilterScript();
    if (typeof observePriceRangeChanges === 'function') observePriceRangeChanges();
  });

  // Re-init after AJAX filter update from theme
  document.addEventListener('on:facet-filters:updated', () => {
    if (typeof syncFiltersOnPageLoad === 'function') syncFiltersOnPageLoad();
    if (typeof initPriceFilterScript === 'function') initPriceFilterScript();
  });
  
}
